import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import ReturningChart from "./ReturningChart";
import StackedChart from "./StackedChart";
import { GET_CUSTOMER_SEGMENTATION_DATA_API } from "../../../../services/ApiCalls";
import { useTranslation } from "react-i18next";

const CustomerReport = () => {
  const { t } = useTranslation();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [dateError, setDateError] = useState(false);

  const fetchAgedistributionGraphData = async ({
    propStart = "",
    propEnd = ""
  }) => {
    setLoading(true);
    try {
      const payload = {
        startDate: propStart || undefined,
        endDate: propEnd || undefined,
      };

      const res = await GET_CUSTOMER_SEGMENTATION_DATA_API(payload);
      if (res?.data?.status === "success") {
        setData(res?.data?.data || {});
      } else {
        console.error("Error:", res?.data?.message || "Failed to fetch");
      }
    } catch (err) {
      console.error("API error:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleCallApiOnDateChange = () => {
    if (startDate && endDate) {
      if (new Date(startDate) > new Date(endDate)) {
        setDateError(true);
        toast.error(t("customerReport.errors.invalidDateRange"));
        return;
      }

      setDateError(false);
      fetchAgedistributionGraphData({
        propStart: startDate,
        propEnd: endDate
      });
    }
  };

  const handleClearDates = () => {
    setDateError(false);
    setStartDate("");
    setEndDate("");
    fetchAgedistributionGraphData({
      propStart: "",
      propEnd: ""
    });
  };

  useEffect(() => {
    fetchAgedistributionGraphData({
      propStart: "",
      propEnd: ""
    });
  }, []);

  return (
    <section className="customer_management p-3">
      <h5 className="fw-bold text-black m-0">
        <span className="me-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#e91e63"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            data-lucide="user-check"
          >
            <path d="m16 11 2 2 4-4"></path>
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
          </svg>
        </span>
        {t("customerReport.title")}
      </h5>

      <hr />

      <p>{t("customerReport.description")}</p>

      <div className="customerCards">
        <div className="d-flex justify-content-end align-items-end gap-3 mb-3">
          <div style={{ width: "150px" }}>
            <label className="small fw-semibold">
              {t("customerReport.filters.startDate")}
            </label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className={`form-control ${dateError ? "border-danger" : ""}`}
            />
          </div>

          <div style={{ width: "150px" }}>
            <label className="small fw-semibold">
              {t("customerReport.filters.endDate")}
            </label>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className={`form-control ${dateError ? "border-danger" : ""}`}
            />
          </div>

          {(startDate || endDate) && (
            <button
              className="btn btn-primary px-4"
              onClick={handleClearDates}
            >
              {t("customerReport.actions.clear")}
            </button>
          )}

          <button
            className="btn btn-primary px-4"
            onClick={handleCallApiOnDateChange}
            disabled={!startDate || !endDate || loading}
          >
            {loading
              ? t("customerReport.actions.loading")
              : t("customerReport.actions.apply")}
          </button>
        </div>

        <Row>
          <Col lg="4" md="6" sm="12" className="my-2">
            <div className="reportCard">
              <p>{t("customerReport.cards.newCustomerRatio")}</p>
              <h2 className="my-1 fw-bold">
                {data?.newCustomerRatio?.toFixed(1) || 0}%
              </h2>
              <small>
                {t("customerReport.cards.vsReturning", {
                  value: data?.returningCustomerRatio?.toFixed(1) || 0
                })}
              </small>
            </div>
          </Col>

          <Col lg="4" md="6" sm="12" className="my-2">
            <div className="reportCard">
              <p>{t("customerReport.cards.genderRatio")}</p>
              <h2 className="my-1 fw-bold">
                {`${data?.genderRatio?.male} : ${data?.genderRatio?.female}` || "0 : 0"}
              </h2>
              <small>{t("customerReport.cards.genderNote")}</small>
            </div>
          </Col>

          <Col lg="4" md="6" sm="12" className="my-2">
            <div className="reportCard">
              <p>{t("customerReport.cards.averageAge")}</p>
              <h2 className="my-1 fw-bold">
                {data?.averageAge || t("customerReport.cards.notAvailable")}
              </h2>
              <small>{t("customerReport.cards.ageNote")}</small>
            </div>
          </Col>

          <Col lg="6" md="6" sm="12" className="my-2">
            {/* <ReturningChart /> */}
            <ReturningChart />
            {/* <ReturningChart dashboardData={mockDurationTypeDistribution} /> */}
            {/* <ReturningChart dashboardData={mockDurationTypeDistributionWithPercent} /> */}
          </Col>

          <Col lg="6" md="6" sm="12" className="my-2">

            {/* <StackedChart/> */}
            <StackedChart />
            {/* <StackedChart data={ageGenderDistributionWithData} /> */}

          </Col>
        </Row>
      </div>
    </section>
  );
};

export default CustomerReport;
